import axios from "axios";
import { urls } from "../../utils/AppManager";
import { getAuthHeaders, getImportAuthHeaders } from "../../utils/headers";

export const getManageUserList = async (
  payload,
  query,
  fromDate,
  toDate,
  sortcolumn,
  sortorder
) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.ManageUserList}?pageNumber=${payload.currentPage}&pageSize=${payload.leadsRecords}&userType=${payload.userType}&userRole=${payload.userRole}&userStatus=${payload.userStatus}&searchQuery=${query}&fromDate=${fromDate}&toDate=${toDate}&role=${payload.userRoleId}&sortcolumn=${sortcolumn}&sortorder=${sortorder}`;
  // console.log(url);
  const headers = getAuthHeaders();
  // console.log(headers, "checking headere values");
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getUserRole = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.userrole;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getUserType = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.userType;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getUserStatus = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.userstatus;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const userEntityDetails = async (roleId, permission, type) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.userentitydetails}?role=${roleId}&permission=${permission}&type=${type}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const userEntityDetailsByRole = async (roleId, permission, type) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.manageUsersEntityEdit}?role=${roleId}&permission=${permission}&type=${type}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const addUser = async (payload, accessKey, secretKey) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.addUser}?accesskey=${accessKey}&secretkey=${secretKey}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const importUser = async (file, userEmail, fieldMappings) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.userImport;
  //console.log(url);
  const formData = new FormData();
  formData.append("file", file); // 'file' is the field name expected by the server
  formData.append("email", userEmail);
  formData.append("fieldMappings", JSON.stringify(fieldMappings));
  const headers = getImportAuthHeaders();
  const res = await axios
    .post(url, formData, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const exportUser = async (value, schemaname, userEmail, filtersData) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.userExport}?relatedusersid=${value}&fieldsName=${schemaname}&userEmail=${userEmail}&userType=${filtersData?.userType}&userStatus=${filtersData?.userStatus}&userRole=${filtersData?.userRole}&fromDate=${filtersData?.fromDate}&toDate=${filtersData?.toDate}`;
  //console.log(url, value, "line 163");
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const deleteUser = async (payload) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.userDelete;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const changeUserPassword = async (leadsIDs, inputValue) => {
  //console.log(leadsIDs);
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.userPassword}?userIdData=${leadsIDs}&passValue=${inputValue}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

// getting email from user to send email.
export const forgotUserPassword = async (payload) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.userForgotPassword;
  const res = await axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  //console.log(res);
  return res;
};

export const resetUserPassword = async (payload) => {
  //console.log(leadsIDs);
  const url = process.env.REACT_APP_API_BASE_URL + urls.userResetPassword;
  const res = await axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getUserRoleMaster = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.userRoleMaster;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getUserReportingList = async (role) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.userReportingList}?role=${role}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getRolesList = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.rolesList;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getRolePermission = async (role) => {
  const url =
    process.env.REACT_APP_API_BASE_URL + `${urls.rolePermissions}?role=${role}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getRoleAllPermission = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.allRolePermissions;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const updatePermission = async (payload) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.updateRolePermission;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};
export const editUserBulk = async (payload, accessKey, secretKey) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.editUserBulk}?accesskey=${accessKey}&secretkey=${secretKey}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getEntityPermissions = async (
  roleId,
  moduleId,
  permission,
  moduleName
) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.entityPermissions}?roleId=${roleId}&moduleId=${moduleId}&permission=${permission}&modulename=${moduleName}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const updateEntityPermission = async (payload) => {
  const url =
    process.env.REACT_APP_API_BASE_URL + urls.updateRoleEntityPermission;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getUserLovValues = async (displayname) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.userLov}?displayname=${displayname}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

// user details

export const getUserDetails = async (payload) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.userDetails}?userid=${payload}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

// multi edit fields

export const userMultiFieldEdit = async (payload, accessKey, secretKey) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.usermultifieldedit}?accesskey=${accessKey}&secretkey=${secretKey}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getReportingUsers = async (userId, userRole) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.getreportingusers}?userid=${userId}&userRole=${userRole}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getWhitelistedIP = async () => {
  const url = process.env.REACT_APP_API_BASE_URL + `${urls.getwhitelistedips}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const addWhitelistedIP = async (payload) => {
  const url = process.env.REACT_APP_API_BASE_URL + `${urls.addwhitelistedip}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const removeWhitelistedIP = async (payload) => {
  const url =
    process.env.REACT_APP_API_BASE_URL + `${urls.removewhitelistedip}`;
  const headers = getAuthHeaders();
  const res = await axios
    .post(url, payload, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const verifyForgotPassLink = async (payload) => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.validateForgotPassLink;
  const res = await axios
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });

  return res;
};